import {observer} from "mobx-react";
import {Page, PageContentTitle, Pager, Searchbar} from "../../ui";
import {stsOverviewStore} from "../../../store";
import {useNavigate} from "react-router";
import {StsOverviewList} from "./StsOverviewList";
import {StsFilterBar} from "./StsFilterBar";

const StsOverviewPage = observer(function StsOverviewPage() {
    const navigate = useNavigate()
    const display = 'Neue Umlagerung anlegen'

    return <Page
        breadcrumb={[
            {
                link: '/sts',
                label: `Umlagerung`
            },
        ]}
        actions={[
            {
                label: display,
                action: () => navigate('/sts/create'),
                icon: 'add'
            }
        ]}
    >
        <PageContentTitle
            actionItem={<>
                {<StsFilterBar/>}
            </>}
        >
            <Searchbar placeholder={"FIN"}/>
        </PageContentTitle>
        <StsOverviewList />
        <Pager total={stsOverviewStore.pages} />
    </Page>
})

export {
    StsOverviewPage
}
